'use strict';

const {__} = wp.i18n;

/**
 * Init All Custom Fields Logic
 */
class TWER_CUSTOM_FIELDS {

  /**
   * Uploads constructor
   *
   * @param props
   */
  constructor(props) {
    // Init JQuery
    this.$ = $ = props;

    $('.js-ui-slider-wrap').each((index, element) => {
      const $sortableList = $(element);
      $sortableList.sortable({
        cursor: 'move',
        placeholder: 'ui-sortable-placeholder twer-tr-toggle js-ui-slider-item',
        forcePlaceholderSize: true,
        forceHelperSize: true,
        scroll: true,
        revert: false,
        tolerance: 'pointer',
        handle: '.js-twer-ui-sort-tr',
        items: '> .js-ui-slider-item',
        create : function() {
          const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        },
        update: function(event, ui) {
         const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        }
      }).disableSelection();
    });


    $('input:checkbox').each(function(){

      const readOnly = $(this).attr('readonly');

      if(readOnly === 'readonly') {
        $(this).closest('.col-fixed').css({pointerEvents: "none"});
      }

    });

    $(document).on('click', '.js-twer-ui-del-tr', function(e) {
      e.preventDefault();
      const $sortableList = $(this).closest('.js-ui-slider-wrap');
      const $input = $sortableList.find('input.js-twer-custom-fields-list');
      const $select = $sortableList.find('#treweler-custom-field-add');
      const ids = [];
      const id = $(this).closest('.js-ui-slider-item').data('id');
      const label = $(this).closest('.js-ui-slider-item').find('th label').text();
      $select.append('<option value="'+id+'">'+label+'</option>');


      $(this).closest('.js-ui-slider-item').remove();
      $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
        ids.push($(div).data('id'));
      });
      $input.val(ids.join(','));
    });


    $(document).on('click', '.js-add-custom-field', function(e){
      e.preventDefault();

      const $select = $('#treweler-custom-field-add');
      const selectedId = $select.val();
      if('none' !== selectedId) {
        const $row = $('.js-hidden-item[data-id="' + selectedId + '"]').clone();
        const ids = [];
        $row.toggleClass('d-none js-ui-slider-item');
        $row.removeClass('js-hidden-item');

        $row.find('input:not(:checkbox):not(.js-twer-lock-status)').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',true);
          $input.val($input.data('default'));
          $input.attr('value',$input.data('default'));
        });

        $row.find('input.js-twer-lock-status').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',false);
          $input.val('close');
          $input.attr('value','close');
        });

        $row.find('.js-twer-lock').removeClass('twer-lock--open');

        //$row.find('input:checkbox').prop( "checked", false );

        $row.find('input:checkbox').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',true);
          $input.prop( "checked", $input.data('default') );

          $input.closest('.col-fixed').css({pointerEvents: "none"});
        });


        $row.insertBefore('.js-hidden-item:first');
        $select.find('option:selected').remove();
        const $sortableList = $(this).closest('.js-ui-slider-wrap');
        const $input = $sortableList.find('input.js-twer-custom-fields-list');
        $sortableList.sortable('refresh');
        $sortableList.sortable('refreshPositions');
        $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
          ids.push($(div).data('id'));
        });
        $input.val(ids.join(','));
      }
    });


    $(document).on('click','.js-twer-lock', function(e) {
      e.preventDefault();

      const $lock = $(this);
      const index = $lock.index();
      const lockStatus = $lock.hasClass('twer-lock--open') ? 'open' : 'close';
      let $field = $lock.closest('.twer-wrap-fields').find('.twer-group-elements .row');

      if($field.length > 0) {
        $field = $field.children().eq(index);
      } else {
        $field = $lock.closest('.twer-wrap-fields').find('.twer-form-group');
      }



      if('open' === lockStatus) {
        const $input = $field.find('input:not(.js-twer-lock-status):not(:checkbox)');
        $input.prop('readonly', true);
        $input.data('current', $input.val());
        $input.val($input.data('default'));
        $input.attr('value', $input.data('default'));
        $lock.removeClass('twer-lock--open');

        $field.find('.js-twer-lock-status').val('close');
        $field.find('.js-twer-lock-status').attr('value', 'close');


        const $checkbox = $field.find('input:checkbox');
        $checkbox.prop('disabled',false);
        $checkbox.prop('readonly',true);
        $checkbox.data('current', $checkbox.is(':checked'))
        $checkbox.prop( "checked", $input.data('default') );
        $checkbox.closest('.col-fixed').css({pointerEvents: "none"});
      }

      if('close' === lockStatus) {
        const $input = $field.find('input:not(.js-twer-lock-status):not(:checkbox)');
        $input.prop('readonly', false);
        $input.val($input.data('current'));
        $input.attr('value', $input.data('current'));
        $lock.addClass('twer-lock--open');

        $field.find('.js-twer-lock-status').val('open');
        $field.find('.js-twer-lock-status').attr('value', 'open');


        const $checkbox = $field.find('input:checkbox');
        $checkbox.prop('disabled',false);
        $checkbox.prop('readonly',false);
        $checkbox.prop( "checked", $checkbox.data('current') );
        $checkbox.closest('.col-fixed').css({pointerEvents: "auto"});
      }

    })
  }

}

export default TWER_CUSTOM_FIELDS;
